import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formValueSelector, change } from 'redux-form'
import { useMount, useDidUpdate } from 'react-nb-hooks'
import styled from 'styled-components'
import { translate } from 'loankeeper-common/helpers'

import FormField from '../../shared/newFormElements'
import { getOrderAddFlags, setOrderAddFlags } from '../helpers'

const FormFieldWrapper = styled(FormField)`
  &.ui.checkbox label:hover {
    color: inherit;
  }

  &.ui.checkbox input:focus ~ label {
    color: inherit;
  }
`

const AuthorizeCheckbox: FC<{ FormName: string }> = ({ FormName }) => {
  const dispatch = useDispatch()

  const selectFormValue = formValueSelector(FormName)

  const authorize: string = useSelector((state) => selectFormValue(state, 'Authorize'))
  const visible: boolean = useSelector((state) => selectFormValue(state, 'action') === 'add')

  useMount(() => {
    const orderAddFlags: { [key: string]: { [key: string]: any } } = getOrderAddFlags(FormName)

    if (orderAddFlags[FormName].authorize && visible) {
      dispatch(change(FormName, 'Authorize', orderAddFlags[FormName].authorize))
    }
  })

  useDidUpdate(() => {
    const flagsState = getOrderAddFlags(FormName)

    flagsState[FormName].authorize = authorize || '0'

    setOrderAddFlags(flagsState)
  }, [authorize])

  if (!visible) {
    return null
  }

  return <FormFieldWrapper name="Authorize" type="checkbox" label={translate('frm_acc_entry_add-chk_auth')} />
}

export default AuthorizeCheckbox
